import { serverSideTranslations } from "@/libs/i18n/serverSideTranslations";
import { ContactUsData, ContactUsPost } from "@/models/ContactUs";
import { ContactUsPageLayout } from "@/components/support/layouts/ContactUsPageLayout";
import PageTemplate from "@/components/templates/PageTemplate";
import dynamic from "next/dynamic";

const ContactUsDetail = dynamic(
  () =>
    import("@/v2-components/pages/support/components/contact-us/contact-us-detail/contact-us-detail"),
  { ssr: false },
);

export default function SupportDetailsPage({
  issues,
}: {
  issues: ContactUsPost[];
}) {
  return (
    <PageTemplate>
      <PageTemplate.Content>
        <ContactUsPageLayout>
          <ContactUsDetail issues={issues} />
        </ContactUsPageLayout>
      </PageTemplate.Content>
    </PageTemplate>
  );
}

export async function getServerSideProps({ params, locale }) {
  const { type, slug } = params;

  /*
 contact us json data
 - public/docs/contact-us-support.xlsx 에서 변환된
 */
  const jsonData = require("@/../public/res/contact-us-support.json");

  let contactUsData: ContactUsData[] = jsonData || [];

  const filteredContactUsData = contactUsData?.find(
    (item) => item.__typename === type,
  );
  const issues =
    filteredContactUsData?.data.find((item) => item.slug === slug)?.issues ||
    [];

  return {
    props: {
      issues,
      ...(await serverSideTranslations(locale, ["support", "gnb"])),
    },
  };
}
